import { IGameState } from 'State/Game/IGameState';
import IPlayerData from 'Player/IPlayerData';
import { DataConflictRestoreSelection } from 'State/Game/DataConflictRestoreSelection';
import { resetEventHandlerData, syncGameStateWithTracking, track } from '../Track';
import { DataRestoreEventName } from '../TrackingEvent';
import { PlayerDataLocation } from 'Utility/DataConflict/DataConflictsHelper';

export function trackDataConflictResolution(
    state: IGameState,
    playerData: IPlayerData,
    restoreSelection: DataConflictRestoreSelection,
    playerDataSelection: PlayerDataLocation
): void {
    syncGameStateWithTracking(state);
    track('playerDataSelection', playerDataSelection);
    track('restoreSelection', restoreSelection);
    resetEventHandlerData(DataRestoreEventName.dataRestore, state);
}
